import { render, staticRenderFns } from "./MergeFile.vue?vue&type=template&id=438cd04a&scoped=true"
import script from "./MergeFile.vue?vue&type=script&lang=js"
export * from "./MergeFile.vue?vue&type=script&lang=js"
import style0 from "./MergeFile.vue?vue&type=style&index=0&id=438cd04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438cd04a",
  null
  
)

export default component.exports